import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import SVG from "src/utils/SVG";
import { type } from "os";
import cn from "classnames";
import { isEmpty } from "lodash";

interface ICheckBoxProps {
  id: string;
  label?: string | null;
  checked?: boolean;
  readonly?: boolean;
  type?: string;
  className?: string;
  disabled?: boolean;
  pin?: string;
  onChange?: (e: boolean) => void;
}

const CheckBox = (props: ICheckBoxProps) => {
  const { id, type, label, checked, disabled, pin } = props;
  const [isChecked, setIsChecked] = useState(checked || false);
  const [isDisabled, setIsDisabled] = useState(disabled || false);

  useEffect(() => {
    setIsChecked(checked!);
    // if (pin) {
    // }
  }, [props]);

  // const checkBoxHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setIsChecked(!isChecked);
  // };

  return (
    <CheckBoxSet>
      <label htmlFor={id} className={cn({ round: type, disabled: isDisabled, checked: isChecked })}>
        {type === "round" ? (
          !isEmpty(pin) ? (
            <SVG name="roundCheckDisabled" width={24} height={24} viewBox="0 0 24 24" />
          ) : isChecked ? (
            <SVG name="roundCheckboxActive" width={25} height={25} viewBox="0 0 25 25" />
          ) : (
            <SVG name="roundCheckbox" width={24} height={24} viewBox="0 0 24 24" />
          )
        ) : isChecked ? (
          isDisabled ? (
            <SVG name="checkboxDisabled" width={20} height={20} viewBox="0 0 20 20" />
          ) : (
            <SVG name="checkboxActive" width={20} height={20} viewBox="0 0 20 20" />
          )
        ) : (
          <SVG name="checkbox" width={20} height={20} viewBox="0 0 20 20" />
        )}
        <input
          type="checkbox"
          id={id}
          // checked={isChecked}
          // disabled={isDisabled}
          onChange={(e) => {
            props.onChange && props.onChange!(isChecked);
            // checkBoxHandler(e);
          }}
        />
        {label}
      </label>
    </CheckBoxSet>
  );
};

// CheckBox
const CheckBoxSet = styled.span`
  position: relative;
  display: inline-block;
  label {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    padding-left: 30px;
    vertical-align: middle;
    > svg {
      position: absolute;
      left: 0;
      top: 0;
    }
    input {
      overflow: hidden;
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      border: 0;
      margin: -1px;
      clip: rect(0 0 0 0);
      appearance: none;
    }
    &.round {
      padding-left: 25px;
      color: ${({ theme }) => theme.color.lineSecondary};
      font-family: "Roboto";
      font-weight: 700;
      font-size: 16px;
      &.checked {
        color: ${({ theme }) => theme.color.main};
      }
      > svg {
        top: -3px;
      }
    }
  }
  & + & {
    margin-left: 30px;
  }
`;

export default CheckBox;
